// comes from react-router-dom
import createHistory from "history/createBrowserHistory";

export default createHistory();
